import React from 'react';
import { usePlatformFunctionality } from './context/PlatformFunctionalityProvider';
import { ImageComponentProps } from './types';

export const Image = ({ src, data, alt, width, height, ...rest }: ImageComponentProps) => {
  const { ImageComponent } = usePlatformFunctionality();
  if (ImageComponent) {
    return <ImageComponent src={src} alt={alt} width={width} data={data} height={height} {...rest} />;
  }

  return <img src={src ? src : data.url} alt={alt} width={width} height={height} {...rest} />;
};
